import api from '../../../App/socket';

export const getGroupPermissions = group => (
    api.send({
        api: 'module',
        module: 'App',
        classMethod: 'GetGroupPermissions',
        options: {
            where: { group, entity: 'module' },
        },
    }).then(response => response).catch(error => error)
);

export const getGroupOptionsPermissions = (group, entity, parent_entity_url, url, $or) => (
    api.send({
        api: 'module',
        module: 'App',
        classMethod: 'GetGroupPermissions',
        options: {
            where: {
                group, entity, parent_entity_url, url, $or,
            },
        },
    }).then(response => response).catch(error => error)
);

export const getGroupModelPermissions = (groupId, url) => (
    api.send({
        api: 'module',
        module: 'App',
        classMethod: 'GetGroupPermissions',
        options: {
            where: {
                group: groupId,
                entity: 'model',
                url,
            },
        },
    }).then(response => response).catch(error => error)
);

export const getGroupModelFieldsPermissions = (group, url) => (
    api.send({
        api: 'module',
        module: 'App',
        classMethod: 'GetGroupPermissions',
        options: {
            where: { group, url },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/requests/get_permissions_request.js